"use client";

import { useRef, useEffect } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { YOUZU_API_BASE_URL } from "@/constants/api";
import { createAccessToken } from "@/services/token.service";

export function MagicBackgroundSDK() {
  const magicBgRef = useRef<any>(null);

  useEffect(() => {
    // Ensure the element is available
    const magicBg = magicBgRef.current;
    if (!magicBg) return;

    magicBg.resolveToken = async () => {
      console.log("🔄 Resolving token via proxy...");
      try {
        const token = await createAccessToken();
        console.log("✅ Token resolved successfully");
        return token;
      } catch (error) {
        console.error("❌ Failed to resolve token:", error);
        return null;
      }
    };
  }, []);

  return (
    <div className="space-y-6">
      <Card>
        <CardContent className="p-0 overflow-hidden">
          <youzu-magic-background
            ref={magicBgRef}
            id="magic-bg"
            api-base-url={YOUZU_API_BASE_URL}
            style={{
              display: "block",
              width: "100%",
              minHeight: "280px",
            }}
          />
        </CardContent>
      </Card>
    </div>
  );
}
